const results = [
  { icon: 'ri-user-star-line', text: 'Более самостоятельные сотрудники, которые принимают решения в рамках своей ответственности' },
  { icon: 'ri-check-double-line', text: 'Понятная постановка задач: сотрудники понимают, что и к какому сроку нужно сделать' },
  { icon: 'ri-scissors-cut-line', text: 'Снижение микроменеджмента: руководители перестают контролировать каждый шаг' },
  { icon: 'ri-radar-line', text: 'Более качественный контроль через систему контрольных точек, а не постоянное вмешательство' },
  { icon: 'ri-shield-check-line', text: 'Повышение ответственности руководителей за результат команды' },
  { icon: 'ri-chat-check-line', text: 'Конструктивная обратная связь, которая помогает сотрудникам развиваться' },
  { icon: 'ri-scales-3-line', text: 'Снижение количества повторяющихся конфликтов — проблемы решаются, а не накапливаются' },
  { icon: 'ri-calendar-check-line', text: 'Более эффективные совещания: меньше времени, больше решений' },
  { icon: 'ri-seedling-line', text: 'Развитие кадрового резерва: компания готовит будущих руководителей системно' },
  { icon: 'ri-rocket-line', text: 'Повышение управленческой самостоятельности подразделений' },
  { icon: 'ri-global-line', text: 'Единый управленческий язык: руководители говорят на одном языке и действуют согласованно' },
  { icon: 'ri-refresh-line', text: 'Более системное внедрение изменений с меньшим сопротивлением команды' },
];

export default function CompanyResultsSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Результат развития управленческой команды проявляется не в абстрактных показателях, а в конкретных изменениях управленческой практики.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {results.map((result, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${result.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{result.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}